// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5279 ? "6c44d60f" : chunkId) + "." + {"5279":"83209bb630ac5f21","7229":"a2229afbe0528b8a"}[chunkId] + ".js";
};